/* eslint-disable react/style-prop-object */
import React, { ReactElement, useState } from "react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

import { postUpgradeMailboxNumber } from "redux/handlers/mailDomainContainerHandler";

import { getUserBalance } from "redux/selectors/userSelector";

import { useAppDispatch } from "hooks/reduxHook";

const AddFiveMailbox = ({ id, section }: { id: number; section?: string }): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const userBalance = useSelector(getUserBalance);

 const [open, setOpen] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [selectedAmount, setSelectedAmount] = useState<number>(5);

 const handleOpen = async () => setOpen(true);
 const handleClose = () => setOpen(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postUpgradeMailboxNumber(id, selectedAmount));
  setLoading(false);
  handleClose();
 };

 return (
  <>
   <Button
    variant="kxModalConfirm"
    onClick={handleOpen}
    startIcon={<IconSelector icon="WorkspacePremiumIcon" />}>
    <FormattedMessage id="container.maildomains.upgradeMailboxNumber" />
   </Button>
   <AppModal
    open={open}
    close={handleClose}
    title={intl.formatMessage({ id: "container.maildomains.upgradeMailboxNumber" })}
    handleClose={handleClose}
    handleConfirm={handleConfirm}
    disabled={loading || userBalance < 1.8 * selectedAmount}>
    <Stack spacing={1}>
     {section === "mailboxes" && (
      <Typography variant="subtitle2">
       <FormattedMessage id="container.maildomains.mailboxAdvisor" />
      </Typography>
     )}
     <Typography textAlign="start" variant="subtitle2">
      <FormattedMessage id="container.maildomains.upgradeMailboxNumberMessage" />
     </Typography>
     <Select onChange={(e) => setSelectedAmount(Number(e.target.value))} value={selectedAmount}>
      <MenuItem key="five-mbox" value={5}>
       5
      </MenuItem>
      <MenuItem key="ten-mbox" value={10}>
       10
      </MenuItem>
      <MenuItem key="fifteen-mbox" value={15}>
       15
      </MenuItem>
      <MenuItem key="twenty-mbox" value={20}>
       20
      </MenuItem>
      <MenuItem key="thirty-mbox" value={30}>
       30
      </MenuItem>
      <MenuItem key="fifty-mbox" value={50}>
       50
      </MenuItem>
     </Select>
     <Stack direction="row" spacing={2}>
      <Typography minWidth={150} textAlign="start" fontWeight="bold">
       <FormattedMessage id="server.add.balance" />
      </Typography>
      <Typography>
       <FormattedNumber value={userBalance} style={"currency"} currency="EUR" />
      </Typography>
     </Stack>
     <Stack direction="row" spacing={2}>
      <Typography minWidth={150} textAlign="start" fontWeight="bold">
       <FormattedMessage id="container.maildomains.proPriceTotal" />
      </Typography>
      <Typography>
       <FormattedNumber value={1.8 * selectedAmount} style={"currency"} currency="EUR" />
      </Typography>
     </Stack>
    </Stack>
   </AppModal>
  </>
 );
};

export default AddFiveMailbox;
